import { mutator } from 'satcheljs';
import getStore from '../store/store';
import initializeSettings from '../actions/initializeSettings';
import initializeServiceEditState from '../actions/initializeServiceEditState';
import BookingService from 'owa-service/lib/contract/BookingService';
import getDefaultSchedulingPolicy from 'owa-pbp-option-publishing-settings/lib/selectors/getDefaultSchedulingPolicy';

/**
 * Initializes the personal booking page settings in the store.
 */
export default mutator(initializeSettings, actionMessage => {
    let store = getStore();
    store.services = new Map<string, BookingService>();
    const service: BookingService = actionMessage.pbpSettings.DefaultService;
    if (service) {
        store.services.set(service.ServiceId, service);
        store.servicesOrder = [service.ServiceId];
    }
    store.serviceEditState = initializeServiceEditState(getDefaultSchedulingPolicy());
});
